/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type Site,
    SiteFromJSON,
    SiteToJSON,
} from '../models/Site';
import {
    type SiteCreate,
    SiteCreateFromJSON,
    SiteCreateToJSON,
} from '../models/SiteCreate';
import {
    type SiteSortKey,
    SiteSortKeyFromJSON,
    SiteSortKeyToJSON,
} from '../models/SiteSortKey';
import {
    type SiteUpdate,
    SiteUpdateFromJSON,
    SiteUpdateToJSON,
} from '../models/SiteUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface SitesCreateSiteRequest {
    siteCreate: SiteCreate;
}

export interface SitesDeleteSiteRequest {
    siteId: string;
}

export interface SitesListSitesRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: SiteSortKey;
}

export interface SitesListSitesMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface SitesReadSiteRequest {
    siteId: string;
}

export interface SitesUpdateSiteRequest {
    siteId: string;
    siteUpdate: SiteUpdate;
}

export interface SitesValidateCreateSiteRequest {
    siteCreate: SiteCreate;
}

export interface SitesValidateUpdateSiteRequest {
    siteId: string;
    siteUpdate: SiteUpdate;
}

/**
 * SitesApi - interface
 * 
 * @export
 * @interface SitesApiInterface
 */
export interface SitesApiInterface {
    /**
     * Creates request options for sitesCreateSite without sending the request
     * @param {SiteCreate} siteCreate 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesCreateSiteRequestOpts(requestParameters: SitesCreateSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new site.
     * @summary Create a site
     * @param {SiteCreate} siteCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesCreateSiteRaw(requestParameters: SitesCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>>;

    /**
     * Create a new site.
     * Create a site
     */
    sitesCreateSite(requestParameters: SitesCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site>;

    /**
     * Creates request options for sitesDeleteSite without sending the request
     * @param {string} siteId 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesDeleteSiteRequestOpts(requestParameters: SitesDeleteSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the site with the given ID.
     * @summary Delete a site
     * @param {string} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesDeleteSiteRaw(requestParameters: SitesDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the site with the given ID.
     * Delete a site
     */
    sitesDeleteSite(requestParameters: SitesDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for sitesListSites without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {SiteSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesListSitesRequestOpts(requestParameters: SitesListSitesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the sites present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List sites
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {SiteSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesListSitesRaw(requestParameters: SitesListSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Site>>>;

    /**
     * Lists all the sites present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List sites
     */
    sitesListSites(requestParameters: SitesListSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Site>>;

    /**
     * Creates request options for sitesListSitesMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesListSitesMetadataRequestOpts(requestParameters: SitesListSitesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Site listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesListSitesMetadataRaw(requestParameters: SitesListSitesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Site listing metadata
     */
    sitesListSitesMetadata(requestParameters: SitesListSitesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for sitesReadSite without sending the request
     * @param {string} siteId 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesReadSiteRequestOpts(requestParameters: SitesReadSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the site specified by the given ID.
     * @summary Get a single site
     * @param {string} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesReadSiteRaw(requestParameters: SitesReadSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>>;

    /**
     * Returns the site specified by the given ID.
     * Get a single site
     */
    sitesReadSite(requestParameters: SitesReadSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site>;

    /**
     * Creates request options for sitesUpdateSite without sending the request
     * @param {string} siteId 
     * @param {SiteUpdate} siteUpdate 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesUpdateSiteRequestOpts(requestParameters: SitesUpdateSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the site specified by the given ID.
     * @summary Update site
     * @param {string} siteId 
     * @param {SiteUpdate} siteUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesUpdateSiteRaw(requestParameters: SitesUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>>;

    /**
     * Update the site specified by the given ID.
     * Update site
     */
    sitesUpdateSite(requestParameters: SitesUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site>;

    /**
     * Creates request options for sitesValidateCreateSite without sending the request
     * @param {SiteCreate} siteCreate 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesValidateCreateSiteRequestOpts(requestParameters: SitesValidateCreateSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new site without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a site
     * @param {SiteCreate} siteCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesValidateCreateSiteRaw(requestParameters: SitesValidateCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new site without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a site
     */
    sitesValidateCreateSite(requestParameters: SitesValidateCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for sitesValidateUpdateSite without sending the request
     * @param {string} siteId 
     * @param {SiteUpdate} siteUpdate 
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesValidateUpdateSiteRequestOpts(requestParameters: SitesValidateUpdateSiteRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given site, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate site update
     * @param {string} siteId 
     * @param {SiteUpdate} siteUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitesApiInterface
     */
    sitesValidateUpdateSiteRaw(requestParameters: SitesValidateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given site, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate site update
     */
    sitesValidateUpdateSite(requestParameters: SitesValidateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SitesApi extends runtime.BaseAPI implements SitesApiInterface {

    /**
     * Creates request options for sitesCreateSite without sending the request
     */
    async sitesCreateSiteRequestOpts(requestParameters: SitesCreateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteCreate'] == null) {
            throw new runtime.RequiredError(
                'siteCreate',
                'Required parameter "siteCreate" was null or undefined when calling sitesCreateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SiteCreateToJSON(requestParameters['siteCreate']),
        };
    }

    /**
     * Create a new site.
     * Create a site
     */
    async sitesCreateSiteRaw(requestParameters: SitesCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.sitesCreateSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     * Create a new site.
     * Create a site
     */
    async sitesCreateSite(requestParameters: SitesCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.sitesCreateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sitesDeleteSite without sending the request
     */
    async sitesDeleteSiteRequestOpts(requestParameters: SitesDeleteSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling sitesDeleteSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/{site_id}`;
        urlPath = urlPath.replace('{site_id}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the site with the given ID.
     * Delete a site
     */
    async sitesDeleteSiteRaw(requestParameters: SitesDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.sitesDeleteSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the site with the given ID.
     * Delete a site
     */
    async sitesDeleteSite(requestParameters: SitesDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sitesDeleteSiteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for sitesListSites without sending the request
     */
    async sitesListSitesRequestOpts(requestParameters: SitesListSitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling sitesListSites().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the sites present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List sites
     */
    async sitesListSitesRaw(requestParameters: SitesListSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Site>>> {
        const requestOptions = await this.sitesListSitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SiteFromJSON));
    }

    /**
     * Lists all the sites present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List sites
     */
    async sitesListSites(requestParameters: SitesListSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Site>> {
        const response = await this.sitesListSitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sitesListSitesMetadata without sending the request
     */
    async sitesListSitesMetadataRequestOpts(requestParameters: SitesListSitesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling sitesListSitesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Site listing metadata
     */
    async sitesListSitesMetadataRaw(requestParameters: SitesListSitesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.sitesListSitesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Site listing metadata
     */
    async sitesListSitesMetadata(requestParameters: SitesListSitesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.sitesListSitesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sitesReadSite without sending the request
     */
    async sitesReadSiteRequestOpts(requestParameters: SitesReadSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling sitesReadSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/{site_id}`;
        urlPath = urlPath.replace('{site_id}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the site specified by the given ID.
     * Get a single site
     */
    async sitesReadSiteRaw(requestParameters: SitesReadSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.sitesReadSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     * Returns the site specified by the given ID.
     * Get a single site
     */
    async sitesReadSite(requestParameters: SitesReadSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.sitesReadSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sitesUpdateSite without sending the request
     */
    async sitesUpdateSiteRequestOpts(requestParameters: SitesUpdateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling sitesUpdateSite().'
            );
        }

        if (requestParameters['siteUpdate'] == null) {
            throw new runtime.RequiredError(
                'siteUpdate',
                'Required parameter "siteUpdate" was null or undefined when calling sitesUpdateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/{site_id}`;
        urlPath = urlPath.replace('{site_id}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SiteUpdateToJSON(requestParameters['siteUpdate']),
        };
    }

    /**
     * Update the site specified by the given ID.
     * Update site
     */
    async sitesUpdateSiteRaw(requestParameters: SitesUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.sitesUpdateSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     * Update the site specified by the given ID.
     * Update site
     */
    async sitesUpdateSite(requestParameters: SitesUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.sitesUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sitesValidateCreateSite without sending the request
     */
    async sitesValidateCreateSiteRequestOpts(requestParameters: SitesValidateCreateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteCreate'] == null) {
            throw new runtime.RequiredError(
                'siteCreate',
                'Required parameter "siteCreate" was null or undefined when calling sitesValidateCreateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SiteCreateToJSON(requestParameters['siteCreate']),
        };
    }

    /**
     * Validate data for a new site without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a site
     */
    async sitesValidateCreateSiteRaw(requestParameters: SitesValidateCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.sitesValidateCreateSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new site without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a site
     */
    async sitesValidateCreateSite(requestParameters: SitesValidateCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sitesValidateCreateSiteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for sitesValidateUpdateSite without sending the request
     */
    async sitesValidateUpdateSiteRequestOpts(requestParameters: SitesValidateUpdateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling sitesValidateUpdateSite().'
            );
        }

        if (requestParameters['siteUpdate'] == null) {
            throw new runtime.RequiredError(
                'siteUpdate',
                'Required parameter "siteUpdate" was null or undefined when calling sitesValidateUpdateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sites/{site_id}/validate`;
        urlPath = urlPath.replace('{site_id}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SiteUpdateToJSON(requestParameters['siteUpdate']),
        };
    }

    /**
     * Validate data for updating the given site, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate site update
     */
    async sitesValidateUpdateSiteRaw(requestParameters: SitesValidateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.sitesValidateUpdateSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given site, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate site update
     */
    async sitesValidateUpdateSite(requestParameters: SitesValidateUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sitesValidateUpdateSiteRaw(requestParameters, initOverrides);
    }

}
